import { AuthInterceptorService } from './services/auth.interceptor.service';
import { SharedModule } from './shared/shared.module';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import solidgauge from 'highcharts/modules/solid-gauge';
// import more from 'highcharts/highcharts-more';
// import * as Highcharts from 'highcharts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// more(Highcharts);
// solidgauge(Highcharts);

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
// tslint:disable-next-line:max-line-length
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";

// import 'hammerjs';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    LoginModule,
    HomeModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    MatTabsModule
  ],

  providers: [MatDatepickerModule,{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptorService,
    multi: true
  },
  {provide: LocationStrategy, useClass: HashLocationStrategy},
  provideAnimationsAsync() ],
  bootstrap: [AppComponent]
})
export class AppModule { }
